export const RectangularTableWithChairs: React.FC<{
  tableId: number;
  status: string;
  timer?: string;
  table?:any;
  tableCode?: string;
  selected?: boolean;
  onClick: () => void;

}> = ({ tableId, status, timer,tableCode,table, selected, onClick }) => {
  const getFillColor = () => {
    switch (status) {
      case 'available':
        return '#4CAF50'; // Green
      case 'booked':
        return '#F44336'; // Red
      case 'reserved':
        return '#FFC107'; // Amber
      case 'available-soon':
        return '#FF9800'; // Orange
      default:
        return '#9E9E9E'; // Grey
    }
  };
  return (
    <svg
      onClick={onClick} // Ensures click event triggers table selection
      width="150"
      height="100"
      viewBox="0 0 150 80"
      xmlns="http://www.w3.org/2000/svg"
      style={{ cursor: 'pointer', margin: '10px', transform: `rotate(${(table.rotation ??0)}deg)` }}
     
    >
      {/* Table */}
      <rect x="30" y="20"  width="90" height="50" fill={getFillColor()} stroke={selected ? '#0000FF' : '#FFF'} strokeWidth="4" />
      <text x="75" y="40" textAnchor="middle" dy=".3em" fontSize="12px" fill="#FFF">
        {tableCode}
      </text>
      {timer && (
        <text x="75" y="60" textAnchor="middle" fontSize="10px" fill="#FFF">
          {timer}
        </text>
      )}

      {/* Chairs */}
      <rect x="10" y="25" width="15" height="30" rx="5" fill="#CCCCCC" />
      <rect x="125" y="25" width="15" height="30" rx="5" fill="#CCCCCC" />
      <rect x="50" y="5" width="50" height="10" rx="5" fill="#CCCCCC" />
      <rect x="50" y="75" width="50" height="10" rx="5" fill="#CCCCCC" />
    </svg>
  );
};
